import React from 'react';
import { RequiredDocument } from './RequiredDocument';
import { PAGE_TEXT } from '../lang';
import { ADDITIONAL_DOCS_TYPE } from '../constants';
import { type RequiredDocumentData } from './types';

const RESEARCH_PROPOSAL = PAGE_TEXT.OTHER_INFORMATION.RESEARCH_PROPOSAL;
export const ResearchProposal: React.FunctionComponent<
  RequiredDocumentData
> = props => {
  const {
    applicationNo,
    docsData = [],
    enableEdit,
    refetchApplication,
    handleLoading,
    enableDelete,
  } = props;

  const identificationInfoDisplay = {
    title: RESEARCH_PROPOSAL.TITLE,
    description: RESEARCH_PROPOSAL.UPLOAD_RESEARCH_PROPOSAL,
    fileName: 'research_proposal',
    filesPanelTitle: RESEARCH_PROPOSAL.FILES_PANEL.PANEL_TITLE,
    filesPanelCaption: RESEARCH_PROPOSAL.TITLE,
  };

  const requiredDocumentProps = {
    fileType: ADDITIONAL_DOCS_TYPE.RESEARCH,
    infoDisplay: identificationInfoDisplay,
    applicationNo,
    requiredDocumentData: docsData,
    enableEdit,
    refetchApplication,
    handleLoading,
    enableDelete,
  };

  return <RequiredDocument {...requiredDocumentProps} />;
};
